<template>
  <div class="customer__form modal modal--default">
    <div class="modal__panel">
      <div class="modal__logo-wrapper">
        <div class="modal__logo"></div>
      </div>

      <div class="modal__main-icon modal__main-icon--setting"></div>
      <div class="modal__close" @click="closeModal()"></div>

      <div class="form">
        <div class="navigators">
          <div class="navigator navigator--active">
            <div class="navigator__bullet"></div>
            <div class="navigator__title">{{ $t(`addPermissionModal.${"title"}`) }}</div>
          </div>
        </div>
        <div class="add__form">
          <transition name="fade" mode="out-in">
            <div class="add__content">
              <div class="form__field">
                <input type="text" class="input input--default" :class="{ 'input--error': permissionNameHasError }"
                  :placeholder="$t(`addPermissionModal.${'permissionPlaceholder'}`)" v-model="permissionName" />
                <div class="form__error" v-if="permissionNameHasError">
                  {{ $t(`addPermissionModal.${"permissionErrorMsg"}`) }}
                </div>
              </div>
            </div>
          </transition>
        </div>
      </div>
      <div v-if="isRequesting" class="modal__button modal__button--submit button button--default button--loading"></div>
      <div v-else>
        <button v-if="$checkRolePermission('permission_create')"
          class="modal__button modal__button--submit button button--default" @click="addPermission()">
          <span>{{ $t(`addPermissionModal.${"saveBtn"}`) }}</span>
        </button>
      </div>
    </div>
  </div>
</template>

<script setup>
import { ref, watch, onMounted, getCurrentInstance } from "vue";
import { useStore } from "vuex";

defineOptions({
  name: "AddPermissionModal"
});

const store = useStore();

// Access the global proxy context for the $checkRolePermission method
const { proxy } = getCurrentInstance();

// Reactive State
const permissionName = ref("");
const permissionNameHasError = ref(false);
const isRequesting = ref(false);

// Watchers
watch(permissionName, (value) => {
  permissionNameHasError.value = !value;
});

// Methods
const closeModal = () => {
  store.commit("setShowAddPermissionModal", false);
};

const addPermission = async () => {
  isRequesting.value = true;
  if (permissionName.value) {
    await store.dispatch("createPermission", permissionName.value);
    await store.dispatch("getPermissions");
    closeModal();
    isRequesting.value = false;
  } else {
    permissionNameHasError.value = true;
    isRequesting.value = false;
  }
};

// Lifecycle Hooks
onMounted(() => {
  if (!proxy.$checkRolePermission('permission_create')) {
    closeModal();
  }
});
</script>
<style scoped lang="scss">
.form__field {
  margin-top: 160px;
}

.modal__button {
  left: 50%;
  transform: translateX(-50%);
  bottom: 200px;
}
</style>
